import React, { Component } from "react";
import { connect } from "react-redux";
import {
    setCreditId,
    setCreditAmount,
    clearCreditMessage,
    giveCredits,
    fetchAllUsers,
    filterUsers,
} from "../../Store/Slices/adminSlice";

class CreditManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
            showDropdown: false,
        };
    }

    componentDidMount() {
        this.props.fetchAllUsers();
    }

    handleSearchChange = (e) => {
        const search = e.target.value;
        this.setState({ search, showDropdown: search.length > 0 });
        this.props.filterUsers(search); // filter locally in slice
    };

    handleSelectUser = (id, userEmail, userName) => {
        this.props.setCreditId(id);
        this.setState({ search: userEmail, showDropdown: false });
    };

    handleAmountChange = (e) => {
        this.props.setCreditAmount(e.target.value);
    };

    handleGiveCredits = () => {
        const { creditId, creditAmount } = this.props;
        if (!creditId  || !creditAmount) return;
        this.props.giveCredits({ UserId: creditId, amount: creditAmount });
    };

    render() {
        const { creditAmount, creditMessage, isGivingCredits, filteredUsers } = this.props;
        const { search, showDropdown } = this.state;

        return (
            <div className="credit-manager p-3" style={{ maxWidth: "500px", margin: "0 auto" }}>
                <h2 className="mb-3">Credit Manager</h2>

                <div className="form-group mb-3 position-relative">
                    <label>User:</label>
                    <input
                        type="text"
                        className="form-control"
                        value={search}
                        onChange={this.handleSearchChange}
                        placeholder="Search user"
                    />
                    {showDropdown && filteredUsers?.length > 0 && (
                        <ul
                            className="dropdown-menu show"
                            style={{
                                width: "100%",
                                maxHeight: "200px",
                                overflowY: "auto",
                                position: "absolute",
                                top: "100%",
                                zIndex: 1000,
                            }}
                        >
                            {filteredUsers.map((user) => (
                                <li
                                    key={user.id}
                                    className="dropdown-item"
                                    onClick={() => this.handleSelectUser(user.id, user.email, user.name)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {user.name} ({user.email})
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className="form-group mb-3">
                    <label>Amount:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={creditAmount}
                        onChange={this.handleAmountChange}
                    />
                </div>

                <button
                    className="btn btn-primary"
                    onClick={this.handleGiveCredits}
                    disabled={isGivingCredits}
                >
                    {isGivingCredits ? "Giving Credits..." : "Give Credits"}
                </button>

                {creditMessage && (
                    <div className="alert alert-info mt-3">{creditMessage}</div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    creditId: state.admin.creditId,
    creditAmount: state.admin.creditAmount,
    creditMessage: state.admin.creditMessage,
    isGivingCredits: state.admin.isGivingCredits,
    filteredUsers: state.admin.filteredUsers,
});

const mapDispatchToProps = {
    setCreditId,
    setCreditAmount,
    clearCreditMessage,
    giveCredits,
    fetchAllUsers,
    filterUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditManager);
